import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Envelope } from './Envelope';
import { Invitation } from './Invitation';


function App() {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <>
            <Envelope onOpen={() => setIsOpened(true)} />
            <Invitation isOpened={isOpened} />
          </>
        } />
      </Routes>
    </Router>
  );
}

export default App;
